// One flag for the whole app: set by ApiClient.onPaused on any 503
// service_paused, cleared by PausedScreen when /api/status says so.
import { useSyncExternalStore } from "react";

let paused = false;
const listeners = new Set<() => void>();

export function setServicePaused(next: boolean): void {
  if (paused === next) return;
  paused = next;
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function useServicePaused(): boolean {
  return useSyncExternalStore(subscribe, () => paused, () => paused);
}
